import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { beam } from '@styles/colors/themes';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 11;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 414px;
  max-height: 676px;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  padding: 16px 24px 24px 24px;
  opacity: 1;
  animation: show 0.2s;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }

  input[type='radio'] {
    display: flex;
    place-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 8px;
  }

  input[type='radio']::before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    background-color: #ffffff;
    border: 1px solid #d0dae3;
  }

  input[type='radio']:checked::before {
    transform: scale(1);
    border: 6.19px solid #1371fe;
  }
`;

export const Text = styled.p`
  display: flex;
  font-family: 'Poppins';
  font-weight: 500;
  font-size: 12px;
  color: #474d66;
  margin-right: 24px;

  &.labels {
    margin-bottom: 8px;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #1a1b1c;
`;

export const RowDiv = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  flex-direction: row;
  justify-content: center;
`;

export const ColumnDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
`;

export const Button = styled.button`
  cursor: pointer;
  align-self: flex-start;

  border: 0;
  background-color: transparent;
  border-radius: 8px;
  padding-top: 6px;
  width: 32px;
  height: 32px;

  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    background-color: #f6f8ff;
  }
`;

interface IInput {
  isError?: boolean;
  isLink?: boolean;
}

export const Input = styled.input<IInput>`
  width: 100%;
  height: 42px;
  border: 1px solid
    ${({ isError }) => (isError ? beam.border.error : '#d8dae5')};
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  margin-bottom: 24px;
  color: ${({ isLink }) =>
    isLink ? beam.color.primaryBlue : beam.font.primary};
  text-decoration-line: ${({ isLink }) => (isLink ? 'underline' : 'unset')};
  transition: all 0.2s;

  ::placeholder {
    font-size: 14px;
    font-weight: 400;
    color: #8f95b2;
  }
`;

interface IAddButton {
  disabled: boolean;
}

export const AddButton = styled.button<IAddButton>`
  display: flex;
  height: 42px;
  align-self: flex-end;
  border: 0;
  border-radius: 8px;
  background-color: ${({ disabled }) => (disabled ? '#edeff4' : '#1371fe')};
  padding: 10px 16px;
  margin-top: 16px;

  font-size: 14px;
  font-weight: 500;
  color: ${({ disabled }) => (disabled ? '#c1c4d6' : '#fff')};

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

interface IRadioButton {
  active?: boolean;
}

export const RadioButton = styled.button<IRadioButton>`
  width: 18px;
  height: 18px;
  background-color: transparent;
  border-radius: 9px;
  border: ${({ active }) =>
    active ? '6.19px solid #1371fe' : '1px solid #d0dae3'};

  margin-right: 8px;
`;

export const Preview = styled.img`
  width: 223.88px;
  height: 150px;
  border-radius: 4px;
  object-fit: cover;
`;

export const PreviewText = styled.p`
  font-family: 'Poppins';
  font-weight: 400;
  font-size: 14;
  color: #1a1b1c;

  margin-bottom: 8px;
`;

export const PreviewContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const FileName = styled.div`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  color: ${beam.font.primary};
  background: #fff;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
  padding-right: 20px;
  border: 1px solid #d8dae5;
  margin-bottom: 24px;

  :disabled {
    border: 1px solid #e9edf1;
    ::placeholder {
      color: ${beam.font.primary};
    }
  }
  ::placeholder {
    color: ${beam.font.label};
  }
`;

export const SelectFile = styled.label`
  display: flex;
  width: 90px;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  color: #696f8c;
  background: #fff;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;

  margin-left: -90px;

  ::-webkit-file-upload-button {
    display: none;
  }

  transition: 0.2s;
  :hover {
    filter: brightness(0.9);
  }
`;

export const IconCloseAwesome = styled(FontAwesomeIcon)`
  position: absolute;
  background: white;
  width: 24px !important;
  padding: 1px 6px;
  right: 0px;
  cursor: pointer;
`;

interface IDivider {
  height: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const PictureInputRow = styled.div`
  display: flex;
  flex-direction: row;
`;
